// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b5ee5299","214":"a3dc12e9","239":"0cc85a12","455":"31180276"}[chunkId] + ".chunk.js";
};